import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DotLoader from '../Loader/DotLoader/DotLoader';
import { getFormattedName } from '../../../selectors/formatName/selector';

import './InfoLabel.scss';

export const InfoLabel = props => {
  const { t } = useTranslation();
  const { loader = false, show, messageKey, user } = props;

  return (
    <div className={`info-label ${show ? 'shown' : 'hidden'}`}>
      {loader === true ? (
        <DotLoader content={t(messageKey, { name: `${user ? getFormattedName({ user }) : '...'}` })} />
      ) : (
        <span>{t(messageKey, { name: `${user ? getFormattedName({ user }) : '...'}` })}</span>
      )}
    </div>
  );
};

InfoLabel.propTypes = {
  messageKey: PropTypes.string.isRequired
};

export default InfoLabel;
